import { FromSchema } from '@40seas/entities/common';
import { z } from 'zod';

export const CreditSafeReportShareHolderSchema = z.object({
    name: z.string().optional(),
    type: z.string().optional(),
    percentage: z.number().optional(),
    address: z.string().optional(),
});

export const CreditSafeReportShareCapitalSchema = z.object({
    shareHolders: z.array(CreditSafeReportShareHolderSchema),
});

export class CreditSafeReportShareHolder extends FromSchema(CreditSafeReportShareHolderSchema) {
    name?: string;
    type?: string;
    percentage?: number;
    address?: string;
}

export class CreditSafeReportShareCapital extends FromSchema(CreditSafeReportShareCapitalSchema) {
    shareHolders: CreditSafeReportShareHolder[];
}
